import { GlobalCarouselTile, prepareTile } from 'components/GlobalCarousel'
import styles from 'components/GlobalCarousel/GlobalCarousel.module.scss'
import { TCourse } from '../../../dataFetching'
import { type CommonTrackProps } from '../../../events'

export type InstructorTileProps = {
  carouselName: string
  content: TCourse
  trackProps: CommonTrackProps & { tileIndex: number }
  setCurrentContent: (course: TCourse) => void
}

export const InstructorTile = ({
  carouselName,
  content,
  setCurrentContent,
}: InstructorTileProps) => {
  const tile = prepareTile(content)

  if (!tile) {
    return null
  }

  const onClickWatchTrailer = content.mediaUuid
    ? () => {
        setCurrentContent(content)
      }
    : undefined

  return (
    <div className={styles.tile}>
      <GlobalCarouselTile
        tile={tile}
        onClickWatchTrailer={onClickWatchTrailer}
        carouselSlug={carouselName}
        location='sub_category_carousel'
      />
    </div>
  )
}
